

<template>
    <el-dialog
        :title="buyerId ? '编辑卖家' : '新建卖家' "
        width="400px"
        :visible.sync="showDialog"
        @closed="refeshRule"
        class="buyer-dialog"
    >
        <el-form ref="buyerForm" label-width="80px" :model="buyer" :rules="rules">
            <el-form-item label="所属店铺" prop="shopId">
                <el-select v-model="buyer.shopId" placeholder="请选择支出类型">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="客户名称" prop="fullName">
                <el-input v-model="buyer.fullName"></el-input>
            </el-form-item>

            <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="buyer.companyName"></el-input>
            </el-form-item>

            <el-form-item label="城市" prop="country">
                <el-input v-model="buyer.country"></el-input>
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
                <el-input v-model="buyer.email"></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button
                v-if="buyerId"
                type="primary"
                size="small"
                class="op-button"
                @click="save()"
            >修改</el-button>
            <el-button
                v-if="!buyerId"
                type="primary"
                size="small"
                class="op-button"
                @click="save()"
            >新增</el-button>
        </div>
    </el-dialog>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
    components: {},
    props: {
        buyerId: { type: Number, default: 0 },
        show: { type: Boolean, default: false },
        added: { type: Function, default: null },
        isRoot: { type: Boolean, default: false },
    },
    data() {
        return {
            showDialog: false,
            shops: null,
            buyer: {},
            rules: {
                fullName: [
                    {
                        required: true,
                        message: "请输入客户名称",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],

                shopId: [
                    {
                        required: true,
                        message: "请选择所属店铺",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        getShops() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/valid"],
                [
                    function (data) {
                        _this.shops = data;

                        if (_this.buyerId) {
                            _this.getBuyer();
                        } else {
                            _this.buyer = {};
                            _this.showDialog = true;
                        }
                    },
                ],
                ".buyer-dialog"
            );
        },
        getBuyer() {
            let _this = this;

            _this.$http.post(
                [
                    _this.isRoot ? "alibaba/buyer/get" : "alibaba/buyer/getMyself",
                    { id: _this.buyerId },
                ],
                [
                    function (data) {
                        _this.buyer = {
                            id: data.id,
                            shopId: data.shopId,
                            fullName: data.fullName,
                            companyName: data.companyName,
                            country: data.country,
                            email: data.email,
                        };

                        _this.showDialog = true;
                    },
                ],
                ".buyer-dialog"
            );
        },
        refeshRule() {
            this.$refs["buyerForm"].resetFields();
            this.$emit("update:show", false);
        },
        save() {
            let _this = this;
            _this.$refs["buyerForm"].validate().then(function () {
                _this.dosave();
            });
        },
        dosave() {
            let _this = this;

            _this.$http.post(
                [_this.isRoot ? "alibaba/buyer/save" : "alibaba/buyer/saveMyself", _this.buyer],
                [
                    function (data) {
                        if (_this.added) {
                            _this.showDialog = false;
                            _this.added();
                        }
                    },
                ],
                ".prdocut-dloaig"
            );
        },
    },
    mounted() {},
    watch: {
        show(val) {
            if (val) {
                this.getShops();
            } else {
                this.showDialog = val;
            }
        },
    },
};
</script>